import { render } from "./OpenaiDesktop.vue?vue&type=template&id=52969e54&scoped=true"
import script from "./OpenaiDesktop.vue?vue&type=script&lang=js"
export * from "./OpenaiDesktop.vue?vue&type=script&lang=js"

import "./OpenaiDesktop.vue?vue&type=style&index=0&id=52969e54&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52969e54"]])

export default __exports__